// Hide elements until Swiper is ready
$('.custom-collection__List .shop_by_category').hide();
$('.custom-collection__List .title-wrapper-with-link').hide();
$('.custom-collection__List .swiper-button-next').hide();
$('.custom-collection__List .swiper-button-prev').hide();

// Track if sections have been initialized to prevent flash on resize
var initializedSections = new Set();

// Function to initialize a single section
function initializeSection($section) {
  var sectionId = $section.attr("id"); // e.g., shop-by-category-123456
  var loadingOverlay = $section.find(".loading-overlay-collection");
  var isAlreadyInitialized = initializedSections.has(sectionId);

  // If already initialized, don't reinitialize
  if (isAlreadyInitialized) {
    return;
  }

  // Initialize Swiper scoped to this section
  var swiperInstance = new Swiper("#" + sectionId + " .shop_by_category", {
    slidesPerView: "auto",
    centerInsufficientSlides: true,
    spaceBetween: 0,
    speed: 1000,
    loop: false,
    freeMode: {
      enabled: true,
    },
    mousewheel: {
      forceToAxis: true,
    },
    pagination: {
      el: "#" + sectionId + " .swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: "#" + sectionId + " .swiper-button-next",
      prevEl: "#" + sectionId + " .swiper-button-prev",
    },
    on: {
      init: function () {
        // Fade out the loading overlay and fade in the slider
        loadingOverlay.fadeOut(500, function () {
          $section.find(".shop_by_category").show();
          $section.find(".title-wrapper-with-link").show();
          $section.find(".swiper-button-next").show();
          $section.find(".swiper-button-prev").show();
        });
      },
    },
  });

  // Save instance reference and mark as initialized
  $section.data("swiperInstance", swiperInstance);
  initializedSections.add(sectionId);

  // Fix disabled navigation button issue
  var $nextBtn = $section.find(".swiper-button-next");
  if ($nextBtn.hasClass("swiper-button-disabled")) {
    $nextBtn.removeClass("swiper-button-disabled swiper-button-lock");
  }
}

// Initialize on load only
$(window).on('load', function () {
  $(".custom-collection__List").each(function () {
    initializeSection($(this));
  });
});

// Handle resize without reinitializing
$(window).on('resize', function () {
  // Only update existing swiper instances, don't reinitialize
  $(".custom-collection__List").each(function () {
    var $section = $(this);
    var swiperInstance = $section.data("swiperInstance");
    if (swiperInstance) {
      // Update swiper on resize without destroying and recreating
      swiperInstance.update();
    }
  });
});
